/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AnnualClockEvent } from './AnnualClockEvent';
import {
    AnnualClockEventFromJSON,
    AnnualClockEventToJSON,
} from './AnnualClockEvent';

/**
 * Represents a month in the annual clock
 * @export
 * @interface AnnualClockMonth
 */
export interface AnnualClockMonth {
    /**
     *
     * @type {string}
     * @memberof AnnualClockMonth
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof AnnualClockMonth
     */
    month: string;
    /**
     *
     * @type {string}
     * @memberof AnnualClockMonth
     */
    description: string;
    /**
     *
     * @type {Array<AnnualClockEvent>}
     * @memberof AnnualClockMonth
     */
    events?: AnnualClockEvent[] | null;
}

/**
 * Check if a given object implements the AnnualClockMonth interface.
 */
export function instanceOfAnnualClockMonth(value: object): value is AnnualClockMonth {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function AnnualClockMonthFromJSON(json: any): AnnualClockMonth {
    return AnnualClockMonthFromJSONTyped(json, false);
}

export function AnnualClockMonthFromJSONTyped(json: any, _: boolean): AnnualClockMonth {
    if (json == null) {
        return json;
    }
    return {

        'title': json['title'],
        'month': json['month'],
        'description': json['description'],
        'events': json['events'] == null ? undefined : ((json['events'] as any[]).map(AnnualClockEventFromJSON)),
    };
}

export function AnnualClockMonthToJSON(json: any): AnnualClockMonth {
    return AnnualClockMonthToJSONTyped(json, false);
}

export function AnnualClockMonthToJSONTyped(value?: AnnualClockMonth | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'title': value['title'],
        'month': value['month'],
        'description': value['description'],
        'events': value['events'] == null ? undefined : ((value['events'] as any[]).map(AnnualClockEventToJSON)),
    };
}
